import React, { lazy, Suspense, useEffect, Component } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { prefetchContent } from "./services/api";
import { AuthProvider } from "./services/AuthContext";
import SignInGate from "./components/SignInGate";

class ErrorBoundary extends Component {
  state = { hasError: false, err: "" };
  static getDerivedStateFromError(e) { return { hasError: true, err: String(e && e.stack ? e.stack : e).slice(0, 600) }; }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{background:"#000",height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:"16px"}}>
          <p style={{color:"#fff",fontSize:"18px"}}>Something went wrong.</p><pre style={{color:"#f87171",fontSize:"11px",maxWidth:"90vw",whiteSpace:"pre-wrap"}}>{this.state.err}</pre>
          <button onClick={() => window.location.reload()} style={{background:"#7c3aed",color:"#fff",padding:"12px 24px",borderRadius:"8px",border:"none",cursor:"pointer"}}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const LoadingScreen = () => (
  <div style={{background:"#000",height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:"16px"}}>
    <div style={{width:"48px",height:"48px",border:"4px solid #7c3aed",borderTopColor:"transparent",borderRadius:"50%",animation:"spin 0.8s linear infinite"}} />
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    <p style={{color:"#666",fontSize:"14px"}}>Loading...</p>
  </div>
);

const LandingPage = lazy(() => import("./components/LandingPage"));
const LoginPage   = lazy(() => import("./components/LoginPage"));
const SignupPage  = lazy(() => import("./components/SignupPage"));
const MainApp     = lazy(() => import("./MainApp"));
const ProfilePage = lazy(() => import("./components/ProfilePage"));
const LiveTVPage  = lazy(() => import("./components/LiveTVPage"));
const YouTubePage = lazy(() => import("./components/YouTubePage"));
const ForgotPasswordPage = lazy(() => import("./components/ForgotPasswordPage"));
const ReferralDashboard = lazy(() => import("./components/ReferralDashboard"));
const AnalyticsDashboard = lazy(() => import("./components/AnalyticsDashboard"));

function App() {
  useEffect(() => { prefetchContent(); }, []);
  return (
    <AuthProvider>
    <Router>
      <ErrorBoundary>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/"        element={window.location.hostname.startsWith("analytics.") ? <AnalyticsDashboard /> : <SignInGate><MainApp /></SignInGate>} />
            <Route path="/login"   element={<LoginPage />} />
            <Route path="/signup"  element={<SignupPage />} />
            <Route path="/app"     element={<SignInGate><MainApp /></SignInGate>} />
            <Route path="/profile" element={<SignInGate><ProfilePage /></SignInGate>} />
            <Route path="/livetv"  element={<SignInGate><LiveTVPage /></SignInGate>} />
            <Route path="/youtube" element={<SignInGate><YouTubePage /></SignInGate>} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/referrals" element={<ReferralDashboard />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
    </AuthProvider>
  );
}
export default App;





